<template>
  <div id="coredata-overview">
    <!-- start tabs -->
    <vs-tabs class="coredata-tabs p-4">
      <!-- itterate tabs -->
      <vs-tab
        v-for="(group, index) of resourceGroups"
        :key="index"
        :label="group.name"
      >
        <!-- start accordion -->
        <vs-collapse accordion style="background: white">
          <!-- itterate accordion items (groups  ressources) -->
          <vs-collapse-item
            v-for="currentResource of group.resources"
            :key="currentResource.overviewQuery"
          >
            <!-- label -->
            <div slot="header" @click="openResource(currentResource)">
              {{ currentResource.name }}
            </div>
            <!-- create new -->
            <div class="create-form vx-row mt-3">
              <div class="vx-col w-full">
                <CoredataForm
                  :form-fields="
                    currentResource.fields || [
                      { label: 'Bezeichung', name: 'name' }
                    ]
                  "
                  @submit="saveEntry"
                  @delete="deleteEntry"
                />
              </div>
              <!-- list -->
              <div class="vx-col w-full">
                <div
                  v-for="(tr, trindex) in results"
                  :key="tr.id"
                  class="custom-accordion"
                  style="width: 100%"
                >
                  <div
                    class="custom-accordion--item"
                    :class="{
                      'is-active': tr.isOpen
                    }"
                  >
                    <button
                      class="custom-accordion--header"
                      @click="toggleAccord(trindex)"
                    >
                      {{ tr.name ? tr.name : tr.nameHistory }}
                      <i class="far fa-chevron-down"></i>
                    </button>
                    <div
                      v-if="tr.isOpen"
                      class="accordion-content"
                      :class="{
                        open: tr.isOpen
                      }"
                    >
                      <CoredataForm
                        :entry-index="trindex"
                        :value="
                          (() => {
                            return tr;
                          })()
                        "
                        :form-fields="
                          currentResource.fields || [
                            { label: 'Bezeichung', name: 'name' }
                          ]
                        "
                        @submit="saveEntry"
                        @delete="deleteEntry"
                      />
                    </div>
                  </div>
                </div>
                <vs-pagination
                  :value="currentPage"
                  :total="Math.ceil(totalResults / pageSize)"
                  :max="7"
                  icon-pack="fas"
                  prev-icon="fa-chevron-left"
                  next-icon="fa-chevron-right"
                  @input="fetchPage"
                />
              </div>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import CoredataForm from "./CoredataForm";
import { Resources, ResourceGroups } from "@/data/coredata";
import gql from "graphql-tag";

const pageSize = 30;

export default {
  components: {
    CoredataForm
  },
  data: () => ({
    currentPage: 1,
    results: null,
    totalResults: null,
    currentResource: null,
    resources: Resources,
    resourceGroups: ResourceGroups,
    pageSize
  }),
  computed: {
    queryFields() {
      if (!this.currentResource.fields) {
        return "name\n";
      }

      return this.currentResource.fields
        .map(field => {
          return field.name;
        })
        .join("\n");
    },
    inputFields() {
      if (!this.currentResource.fields) {
        return "name\n";
      }

      return this.currentResource.fields
        .map(field => {
          return field.inputName;
        })
        .join("\n");
    }
  },
  mounted() {
    if (this.$route.params.resource) {
      let resource = Resources.find(
        el => el.overviewQuery === this.$route.params.resource
      );
      this.currentResource = resource;
      this.fetchPage();
    }
  },
  methods: {
    openResource(resource) {
      // console.log("openResource()");
      this.$router
        .replace({
          name: "coredata.view",
          params: { resource: resource.overviewQuery }
        })
        .catch(() => {});
      this.results = []; // clear old results, to prevent them beeing shown in the newly opened resource
      this.currentResource = resource;
      this.fetchPage();
    },
    toggleAccord(index) {
      this.results[index].isOpen = !this.results[index].isOpen;
      this.$forceUpdate();
    },
    fetchPage(page = 1) {
      if (!this.currentResource) return;

      this.currentPage = page;
      // TODO: Fix page one
      if (!this.$apollo.queries[this.currentResource.overviewQuery]) {
        this.$apollo.addSmartQuery(this.currentResource.overviewQuery, {
          query: gql`query ($page: Int!) {
          ${this.currentResource.overviewQuery}(page: $page, size: ${pageSize}) {
              results {
                id
                ${this.queryFields}
              }
              total
            }
          }`,
          fetchPolicy: "network-only",
          variables: {
            page
          },
          result({ data }) {
            this.results = JSON.parse(
              JSON.stringify(data[this.currentResource.overviewQuery].results)
            );

            // accordeon handler
            for (let index = 0; index < this.results.length; index++) {
              setTimeout(() => (this.results[index].isOpen = false), 0);
            }

            this.totalResults = data[this.currentResource.overviewQuery].total;
          }
        });
        this.$apollo.queries[this.currentResource.overviewQuery].start();
      } else if (page === 1) {
        this.$apollo.queries[this.currentResource.overviewQuery].refresh();
      } else {
        this.$apollo.queries[this.currentResource.overviewQuery].fetchMore({
          variables: {
            page
          },
          // Transform the previous result with new data
          updateQuery: (previousResult, { fetchMoreResult }) => {
            const results = JSON.parse(
              JSON.stringify(
                fetchMoreResult[this.currentResource.overviewQuery].results
              )
            );
            const total =
              fetchMoreResult[this.currentResource.overviewQuery].total;

            return {
              [this.currentResource.overviewQuery]: {
                __typename:
                  previousResult[this.currentResource.overviewQuery].__typename,
                results,
                total
              }
            };
          }
        });
      }
    },
    async saveEntry(e) {
      delete e.data.isOpen; // delete isOpen (accord. toggle var) - since it cant be processed in backend
      const inputDataType =
        this.currentResource.inputDataType || "DefaultCoreDataInput";
      if (e.data.id) {
        let entry = await this.$apollo.mutate({
          mutation: gql`
            mutation ($id: ID!, $input: ${inputDataType}!){
              ${this.currentResource.singleQuery}Update(id: $id, input: $input) {
                id
                ${this.queryFields}
              }
            }
          `,
          variables: {
            id: e.data.id,
            input: Object.prepareGqlInput(e.data, [], [], [], {
              "category{name}": "category"
            })
          }
        });

        if (entry.data && !entry.name) {
          entry = entry.data;
        }

        this.results[e.index] =
          entry[this.currentResource.singleQuery + "Update"];

        return;
      }
      let entry = await this.$apollo.mutate({
        mutation: gql`
          mutation ($input: ${inputDataType}!){
            ${this.currentResource.singleQuery}Create(input: $input) {
              id
              ${this.queryFields}
            }
          }
        `,
        variables: {
          input: Object.prepareGqlInput(e.data, [], [], [], {
            "category{name}": "category"
          })
        }
      });

      if (entry.data && !entry.name) {
        entry = entry.data;
      }

      this.results.unshift(entry[this.currentResource.singleQuery + "Create"]);
    },
    async deleteEntry(e) {
      await this.$apollo.mutate({
        mutation: gql`
          mutation ($id: ID!){
            ${this.currentResource.singleQuery}Delete(id: $id) {
              id
            }
          }
        `,
        variables: {
          id: e.data.id
        }
      });

      this.results.splice(e.index, 1);
    }
  }
};
</script>

<style lang="scss">
// .con-expand-users {
//   width: 100%;
//   .list-icon i {
//     font-size: 0.9rem !important;
//   }
// }
#coredata-overview {
  .coredata-tabs {
    .vs-tabs--content {
      padding: 0 !important;
      padding-top: 10px !important;
    }
  }
  .ul-tabs {
    padding: 10px;
    border-radius: 8px;
    li {
      button {
        font-size: 16px;
      }
    }
  }
  .accordion-content {
    height: 0;
    overflow: hidden;
    &.open {
      height: unset;
    }
  }
}
.coredata-tabs {
  .vs-tabs--content {
    padding: 0 !important;
    padding-top: 10px !important;
  }
}
</style>

<style lang="scss" scoped></style>
